import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Provider } from "react-redux";
import store from "./store/store";
import App from "./App";

const darkTheme = createTheme({
  palette: {},
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const env = process.env.REACT_APP_ENV;

console.log(env);

if (env === "dev") {
  root.render(
    <Provider store={store}>
      <ThemeProvider theme={darkTheme}>
        <App />
      </ThemeProvider>
    </Provider>
  );
} else {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider theme={darkTheme}>
          <App />
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );
}
